import { MetaObject } from '../interfaces/meta-object.interface'

export const metaDataContent: {
  [key: string]: MetaObject
} = {
  defaultMeta: {
    title: 'OECD INNOTAX',
    description: '',
    path: ''
  },

  home: {
    title: 'OECD',
    description:
      'An OECD tool to explore and compare R&D tax incentives in OECD countries and partner economies.',
    path: ''
  },

  about: {
    title: 'About',
    description:
      'Background on the OECD INNOTAX portal and its purpose. This page additionally provides information on the data methodology and related OECD work.',
    path: 'about'
  },

  indicators: {
    title: 'Indicators & Analysis',
    description:
      'Quantitative indicators on the policy mix and generosity of public support for R&D and innovation, drawing on the OECD R&D tax incentives database.',
    path: 'indicators-and-analysis'
  },

  comparator: {
    title: 'Tax incentive comparison',
    description:
      'A navigation tool to explore and compare the design of R&D tax incentives in OECD countries and partner economies in a side-by-side comparison.',
    path: 'comparator'
  },

  incentives: {
    title: 'Find Incentives',
    description:
      'A navigation tool to explore and compare the design of R&D tax incentives in OECD countries and partner economies in a side-by-side comparison.',
    path: 'incentives'
  },

  countries: {
    title: 'Country overview',
    description:
      'OECD countries and partner economies: Select a country for obtaining information on country-specific R&D tax incentives and support schemes.',
    path: 'countries'
  },

  // Other.
  error404: {
    title: 'Error 404 : Page not found - OECD RD TAX',
    description: 'We could not find the page you are looking for.',
    path: '404'
  }
}
